/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbRespSearchResultContainer_viewer$ref = any;
export type SbRespSearchResultContainer_viewer = {
    readonly isSeoQuicklookEnabled: boolean | null;
    readonly isTileAdEnabled: boolean | null;
    readonly isFavoritesEnabled: boolean | null;
    readonly isVisuallySimilarEnabled: boolean | null;
    readonly isSbTradeFreeShippingTestDisabled?: boolean | null;
    readonly " $refType": SbRespSearchResultContainer_viewer$ref;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "featureName",
    "value": "NON_MVP_SEARCH_BROWSE"
  }
];
return {
  "kind": "Fragment",
  "name": "SbRespSearchResultContainer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSeoQuicklookEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SEO_QUICKLOOK"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isTileAdEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isFavoritesEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isVisuallySimilarEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "VISUALLY_SIMILAR"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "isSbTradeFreeShippingTestDisabled",
          "name": "isEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "disableSbTradeFreeShippingTest"
            }
          ],
          "storageKey": "isEnabled(key:\"disableSbTradeFreeShippingTest\")"
        }
      ]
    }
  ]
};
})();
(node as any).hash = '576926dea00817f2e7c2175c8282c336';
export default node;
